import {
  ConfirmCashOutRequestEntity,
  ConfirmCashOutResponseEntity
} from '@private/modules/cash-out-payment/core/entities';

export abstract class ConfirmCashOutRepository {

  abstract confirmTransaction(params: ConfirmCashOutRequestEntity): Promise<ConfirmCashOutResponseEntity>;

}
